export default "__VITE_PUBLIC_ASSET__0946a51c__"